export default function PHP_getFile() {
  return (
    <div>
      <h1>PHP_getFile</h1>
    </div>
  );
}
